import { Component, Input, OnInit } from '@angular/core';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { ApiService } from 'src/app/api.service';
import { StripeBrowserService } from 'src/app/stripe-browser.service';
import { PlanCta, PlanNotice } from 'src/shared/api_types';

const SCREEN_NAME_UPGRADE_PLAN = 'Upgrade Plan Modal'

@Component({
  selector: 'app-upgrade-plan',
  templateUrl: './upgrade-plan.component.html',
  styleUrls: ['./upgrade-plan.component.scss'],
})
export class UpgradePlanComponent implements OnInit {

  @Input() planNotice: PlanNotice

  constructor(private api: ApiService,
    private modalController: ModalController,
    private navCtrl: NavController,
    private iab: InAppBrowser,
    private stripeBrowser: StripeBrowserService,
    private loadingController: LoadingController)
  { }

  ngOnInit() {}

  get showStartFreeTrial() {
    return this.planNotice.cta == PlanCta.StartFreeTrial
  }

  get showEnterPaymentDetails() {
    return this.planNotice.cta == PlanCta.EnterPaymentDetails
  }

  get showSubscribePaidPlan() {
    return this.planNotice.cta == PlanCta.SubscribePaidPlan
  }

  get newTrialDays() {
    return this.planNotice.newTrialDays
  }

  async startFreeTrialClick() {
    const loadingElement = await this.loadingController.create({ message: 'Starting free trial...' })
    try {
      await loadingElement.present()
      await this.api.postStartFreeTrial({
        enableSolarTracking: true,
        screenName: SCREEN_NAME_UPGRADE_PLAN,
      })
      // the backend will enable solar tracking
      await this.api.showSuccessAlert('Free trial started. Solar tracking is now enabled.')
      this.modalController.dismiss(true) //tell the caller that we changed the user's subscription
    }
    catch (err: any) {
      await this.api.showErrorAlert(err)
    }
    finally {
      loadingElement.dismiss()
    }
  }

  async openStripePortal() {
    const loadingElement = await this.loadingController.create({ message: 'Loading...' })
    await loadingElement.present()
    try {
      const reply = await this.api.postCreateStripePortalLink()
      loadingElement.dismiss()
      await this.stripeBrowser.openStripe(reply.link)
      this.modalController.dismiss(true)
    }
    catch (err: any) {
      this.api.showErrorAlert(err)
    }
    finally {
      loadingElement.dismiss()
    }
  }

  viewPaidPlansClick() {
    this.navCtrl.navigateForward('/tabs/settings/my-account/my-plan')
    this.modalController.dismiss(false) //we didn't change anything
  }
}
